import React, {
  useEffect,
  useRef,
  useState
} from 'react'
import {Data1} from '../data1';
import {Data2} from '../data2';




function ForexReport() {
  const findMissing = () => {
    const file2Ids = new Set(Data2.map(item => item.id));
    const missing = Data1.filter(item => !file2Ids.has(item.id));
    console.log('Missing JSON:', missing);
  };
  
  findMissing();
  return(
    null
  )
}

export default ForexReport

